import { Key } from "react";
import { Dropdown, DropdownItem } from "staysure-component-library";

import ButtonWrapper from "@/app/shared-components/button-wrapper/button-wrapper";
import ModalWrapper from "@/app/shared-components/modal/modal-wrapper";

import useFamilyModalHook from "./family-modal.hook";
import Styles from "./family-modal.module.css";
import { useCoverForContext } from "../../../provider/cover-for.provider";
import { numberOfParents } from "../../../utils/cover-for-utils";

function FamilyModal() {
  const { cmsData, isFamilyModalOpen, setIsFamilyModalOpen } =
    useCoverForContext();

  const {
    backButtonText,
    confirmButtonText,
    dropDownPlaceHolder,
    familyModalSubText,
    familyModalSubTextEnable,
    familyModalTitleText,
  } = cmsData.overlayArea[0];

  const {
    onBackClick,
    onContinueClick,
    onSelectionChange,
    selectedNumberOfParents,
  } = useFamilyModalHook();

  return (
    <ModalWrapper
      className=" md:p-spacing-xxxl p-spacing-l md:max-w-[416px] max-w-[327px] w-full "
      isOpen={isFamilyModalOpen}
      setIsOpen={(isOpen: boolean) => setIsFamilyModalOpen(isOpen)}
    >
      <div data-testid="family-type-modal">
        <h1
          className="
            text-text-title font-header-font md:text-3xl text-[23px] 
            md:leading-[34.1px] leading-[27.6px] md:mb-spacing-s mb-spacing-xs
          "
        >
          {familyModalTitleText}
        </h1>
        {familyModalSubTextEnable && (
          <div className={Styles.text_content}>{familyModalSubText}</div>
        )}
        <div
          className={`
            ${Styles.dropdown_wrapper} md:w-[304px] w-[279px] mx-auto 
            md:h-[56px] mt-spacing-l md:mb-spacing-l mb-spacing-l
          `}
        >
          <Dropdown
            id="family-type-modal-dropdown"
            className={`
              ${Styles.dropdown_btn} py-spacing-m py px-spacing-m 
              flex space-between w-full
            `}
            strokeColor="#272427"
            placeholderText={dropDownPlaceHolder}
            placeholderTextStyle={{ color: "#272427" }}
            listBoxStyle={{
              outline: "none",
              margin: "0px 0px 0px 0px",
              minWidth: "unset !important",
              boxShadow: "0px 0px 12px 0px rgba(15, 23, 42, 0.11)",
            }}
            onSelectionChange={(e: Key | null) => {
              if (e) onSelectionChange(e as string);
            }}
            unorderedListClassName={`
              md:w-[304px] w-[279px] !md:ml-0 !ml-[-1px] !mt-[-4px] 
              !border-border-subdued !rounded-radius-lg !px-spacing-m 
              !py-spacing-xs
            `}
          >
            {numberOfParents.map((parent) => (
              <DropdownItem value={parent.label} key={parent.label}>
                <span
                  className="
                    w-full leading-[27px] Proxima Nova text-[18px] font-bold 
                    p-spacing-xs hover:bg-interactive-action-hovered 
                    country-name focus:bg-interactive-action-hovered 
                    text-text-on-primary
                  "
                >
                  {parent.label}
                </span>
              </DropdownItem>
            ))}
          </Dropdown>
        </div>
        <div className="flex md:flex-row flex-col">
          <ButtonWrapper
            id="family-type-modal-continue-button"
            isDisabled={!selectedNumberOfParents}
            hierarchy="primary"
            label={confirmButtonText ?? "Continue"}
            onClick={onContinueClick}
            className="
              md:mr-2 md:mb-0 mb-2 !h-[48px] md:w-[148px] w-full 
              leading-[18px] text-text-on-primary
            "
          />
          <ButtonWrapper
            id="family-type-modal-back-button"
            hierarchy="secondary"
            label={backButtonText ?? "Back"}
            onClick={onBackClick}
            className="
              !h-[48px] md:w-[148px] w-full leading-[18px]
            "
          />
        </div>
      </div>
    </ModalWrapper>
  );
}

export default FamilyModal;
